<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-add-button/lecture-add-button.component.ts.LectureAddButtonComponent.html